import SocialSecurityContributionViewComponent from "../components/SocialSecurityContributionEdit";
import useSocialSecurityContributionEdit from "../hooks/useSocialSecurityContributionEdit";

const SocialSecurityContributionEdit = (props) => {
  const socialSecurityContributionEditProps = useSocialSecurityContributionEdit(props);
  return <SocialSecurityContributionViewComponent {...socialSecurityContributionEditProps} />;
};

export default SocialSecurityContributionEdit;
